import React, { memo } from 'react';
export const ExtendedTestimonialsSection = ({
  isInitial = false
}: {
  isInitial?: boolean;
}) => {
  const initialTestimonials = [{
    initials: 'MP',
    name: 'Martha R.',
    city: 'Family Caregiver',
    desc: 'Daughter and primary caregiver · Supporting mother with mild cognitive changes',
    quote: "My mom is 78 and was starting to have frequent memory lapses. I didn't know how to help her without making her feel bad. With the Sharp Mind Workbook, we now spend an hour doing activities together every afternoon. It's the first resource she actually enjoys and that I can understand. The activities gave us a more meaningful daily routine."
  }, {
    initials: 'RC',
    name: 'Richard G.',
    city: 'Professional Caregiver',
    desc: 'Professional in-home caregiver',
    quote: 'I work as an in-home caregiver and the VIP Module with 150+ exercises completely changed how I work. I have physical and cognitive activities organized by levels for each client. Families are happy because they see a professional, organized plan. I never have to improvise anymore.'
  }, {
    initials: 'SL',
    name: 'Susan M.',
    city: 'Family Caregiver',
    desc: 'Primary caregiver for an aging parent',
    quote: "The Vital Nutrition 60+ bonus was a lifesaver. My dad has high blood pressure and diabetes and I didn't know what to cook that was both safe and enjoyable. The recipes are simple with everyday ingredients. I finally felt more organized and confident at mealtimes."
  }];
  const extendedTestimonials = [...initialTestimonials, {
    initials: 'GP',
    name: 'Grace P.',
    city: 'Family Caregiver',
    desc: "Family member supporting an older adult with Parkinson's",
    quote: "The Expert Care Protocol is exactly what I needed to care for my mother-in-law with Parkinson's. Before, I didn't know what to do when she had episodes of stiffness. Now I have a clear protocol and know exactly when to call the doctor. It gave me back my peace of mind."
  }, {
    initials: 'LF',
    name: 'Linda F.',
    city: 'Family Caregiver',
    desc: 'Daughter and primary caregiver',
    quote: "The Vitality 360 Health Tracker organized everything that used to be scattered notes. Now I bring complete records of blood pressure, blood sugar and medications to my dad's doctor appointments. The tracker made medical appointments easier to prepare for. And I sleep better knowing I have everything under control."
  }, {
    initials: 'JR',
    name: 'James R.',
    city: 'Family Caregiver',
    desc: 'Grandson and family caregiver',
    quote: "I never imagined I'd be able to exercise with my grandfather. Move with Confidence has everything explained with clear illustrations. We do the seated routines together for 20 minutes a day. We now have activities we can enjoy together. It's a connection I didn't expect."
  }, {
    initials: 'AM',
    name: 'Anne M.',
    city: 'Family Caregiver',
    desc: 'Daughter and family organizer',
    quote: "The Family Connection Kit saved our Sunday family gatherings. The Reminiscence Cards got my dad telling stories from his youth that we'd never heard before. My 12-year-old son was fascinated. We cried with emotion. It's the most valuable gift we've received."
  }, {
    initials: 'CM',
    name: 'Carol M.',
    city: 'Primary Caregiver',
    desc: 'Primary caregiver for an aging parent',
    quote: 'The Empowered Caregiver Guide saved my year. I was on the edge of burnout caring for my mom alone. The burnout assessment showed I was in the red zone. The guide helped our family share responsibilities. Today I care with boundaries and without guilt.'
  }];
  const data = isInitial ? initialTestimonials : extendedTestimonials;
  return <section className={`py-10 md:py-16 px-4 md:px-6 ${isInitial ? 'bg-familia-bg' : 'bg-familia-card'}`} data-id="element-54">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-55">
        {!isInitial && <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-56">
            Real Families. Real Results. <br className="hidden sm:block" data-id="element-57" />{' '}
            Here's What Changed When They Stopped Improvising:
          </h2>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-58">
          {data.map((t, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-5 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-59">
              <div className="flex items-center gap-4 mb-4 md:mb-6" data-id="element-60">
                <div className="w-12 h-12 rounded-full bg-familia-cyan text-familia-bg flex items-center justify-center font-bold text-lg shrink-0" data-id="element-61">
                  {t.initials}
                </div>
                <div data-id="element-62">
                  <div className="text-familia-gold text-sm mb-1" data-id="element-63">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <div className="font-bold text-sm" data-id="element-64">{t.name}</div>
                  <div className="text-familia-gray text-[10px] uppercase tracking-wider" data-id="element-65">
                    {t.city}
                  </div>
                </div>
              </div>
              <p className="text-white/90 italic mb-4 md:mb-6 flex-grow leading-relaxed text-[15px]" data-id="element-66">
                "{t.quote}"
              </p>
              <div className="text-xs font-semibold text-familia-cyan/90 pt-4 border-t border-white/10" data-id="element-67">
                {t.desc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};